<script>
  import EditView from '../base/EditView.vue'
  import FormInput from '../form/form-input.vue'
  import FormLookup from '../form/form-lookup.vue'

  export default {
    components: {
      EditView,
      FormInput,
      FormLookup,
    },
  }
</script>
<template>
  <edit-view store="project" list-route="ProjectList" v-slot:default="slotProps">
    <form-lookup :store="slotProps.store" prop-name="customer" class="col-4">
      <template v-slot:selected-item="slotProps">
        {{slotProps.item.addr1}}
        {{slotProps.item.addr2}}
      </template>
      <template v-slot:item="slotProps">
        {{slotProps.item.addr1}}<br/>
        {{slotProps.item.addr2}}
      </template>
    </form-lookup>
    <form-input :store="slotProps.store" prop-name="name" class="col-3"></form-input>
  </edit-view>
</template>

